<template>
  <path pid="0" d="M20 3H6a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V6a3 3 0 00-3-3zm1 17a1 1 0 01-1 1H8.41L17 12.41l4 4zm0-6.41l-3.29-3.3a1 1 0 00-1.42 0L5.65 20.94A1 1 0 015 20V6a1 1 0 011-1h14a1 1 0 011 1z"/><path pid="1" d="M9.5 7A2.5 2.5 0 1012 9.5 2.5 2.5 0 009.5 7zm0 3a.5.5 0 11.5-.5.5.5 0 01-.5.5zM5.94 23H6h-.06z"/>
</template>
